import apiClient from "./apiClient";

export class ApplicationEventsService {
  async getApplicationEvents(search, { from, to } = {}) {
    const response = await apiClient.getWithCache("api/applicationEvents/", {
      params: {
        ...search,
        from,
        to,
      },
    });
    return response.data;
  }
}
